import { useEffect, useState } from "react";
import debounce from "lodash/debounce";
import { MOBILE_BREAKPOINT } from "../constants";
export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);
    const calculateBrowserWidth = () => {
        const isSSR = typeof window === "undefined" || typeof document === "undefined";
        const getViewportWidth = () => (isSSR ? 0 : Math.max(document.documentElement.clientWidth, window.innerWidth || 0));
        setIsMobile(!(getViewportWidth() >= MOBILE_BREAKPOINT));
    };
    useEffect(() => {
        if (process.env.NODE_ENV === "test") {
            return;
        }
        calculateBrowserWidth();
        const resizeListener = debounce(calculateBrowserWidth, 1000 / 15);
        window.addEventListener("resize", resizeListener);
        return () => {
            resizeListener.cancel();
            window.removeEventListener("resize", resizeListener);
        };
    });
    return {
        isMobile
    };
};
